import { PlanType } from "../../types/planType";

export const cardBody = {
  padding: "1.5rem 1rem",
  minHeight: 125,
  position: "relative" as React.CSSProperties["position"],
};
export const cardFooter = {
  display: "flex",
  flexWrap: "wrap" as React.CSSProperties["flexWrap"],
  justifyContent: "space-between",
  margin: ".5rem 0.25rem",
  fontWeight: "bold",
};
export const btnPrimary = {
  color: "#253f66",
  fontWeight: 500,
  height: "auto",
  borderRadius: 4,
  padding: "0.5rem 1rem",
};
export const btnOutline = {
  height: "auto",
  backgroundColor: "#253f66",
  color: "#FFF",
  padding: "0.5rem 2rem",
};
export const iconStyles = {
  width: 50,
  height: 50,
  borderRadius: "50%",
  padding: ".25rem",
};
export const callOutIconStyles = (plan: PlanType) => ({
  height: "1.25rem",
  width: "1.25rem",
  color: plan.ef_plan_details?.callout_color || "#00B7F1",
  margin: ".5rem auto",
});

export const glowKeyframes = (plan: PlanType) => `
@keyframes glow {
  0% { opacity: 0.5}
  50% { opacity: 1 }
  100% { opacity: 0.5; }
}
`;
export const baseCardStyle = (
  plan: PlanType,
  isFeatured: boolean = false
): React.CSSProperties => ({
  position: "relative" as React.CSSProperties["position"],
  minHeight: 375,
  maxWidth: "100%",
  margin: "0 auto",
  borderRadius: 8,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: 0,
  borderTop: `.5rem solid ${
    plan.isFeatured ? plan.ef_plan_details?.callout_color : "#00B7F1"
  }`,
});

export const hoverStyles: React.CSSProperties = {
  transform: "scale(1.01)",
};

export const glowPseudoElementStyle = (plan: PlanType) => `
.featured-card::after {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 0 20px ${plan.ef_plan_details?.callout_color || "#00B7F1"};
  opacity: 0;
  animation: glow 3s ease-in-out infinite;
  pointer-events: none;
}
`;

export const featuredCardClassName = "featured-card";
